import axios from "axios";

export const getNotifications = async (data) => {
  const { data: response } = await axios.post(
    "https://sera-prisma.herokuapp.com/api/notifications/user",
    data
  );
  return response;
};

export const getAllNotifications = async (data) => {
  const { data: response } = await axios.get(
    "https://sera-prisma.herokuapp.com/api/notifications",
    data
  );
  return response;
};

export const createNotification = async (data) => {
  const { data: response } = await axios.post(
    "https://sera-prisma.herokuapp.com/api/notifications/create",
    data.variables
  );
  return response;
};

export const deleteNotification = async (data) => {
  const { data: response } = await axios.post(
    "https://sera-prisma.herokuapp.com/api/notifications/delete",
    data.variables
  );
  return response;
};

export const readNotification = async (data) => {
  const { data: response } = await axios.post(
    "https://sera-prisma.herokuapp.com/api/notifications/read",
    data.variables
  );
  return response;
};

export const getNotificationUsers = async (data) => {
  const { data: response } = await axios.get(
    "https://sera-prisma.herokuapp.com/api/notifications/users",
    data
  );
  return response;
};
